module.exports = __webpack_public_path__ + "img/info.f2ffab61.svg";